import React from "react";
import { SXAlert } from "./SXAlert";
import { loadcases_getColor, INVALID_COLOR } from "../helpers/Colors";
import { ng } from "@common/ngds";
import { useTranslation } from "react-i18next";

///////////////////////////////////////////////////////////////////////////////////////////////////
// Constants

const DEFAULT_BEAM = {
  length: { x1: 0.0, z1: 0.0 },
  rotation: 0,
};

const DEFAULT_CONNECTIVITY = [
  { name: "pinned_", id: 0, kx: -1, ky: -1, kz: -1, cx: -1, cy: 0, cz: -1 },
  { name: "rigid_", id: 1, kx: -1, ky: -1, kz: -1, cx: -1, cy: -1, cz: -1 },
  { name: "roller_", id: 2, kx: 0, ky: -1, kz: -1, cx: -1, cy: 0, cz: -1 },
];

///////////////////////////////////////////////////////////////////////////////////////////////////
// Functions

const make_state_type = (value: any, setter: any) => {
  return { value: value, set: setter };
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Components

const LoadCaseColor = (props: { project: any; guid: string | null }) => {
  if (!props.guid || !props.project) {
    return null;
  }

  // Accept both Redux IFile ({ data: Project }) and raw Project objects.
  const project = props.project?.data?.input
    ? props.project
    : props.project?.data?.data?.input
      ? props.project.data
      : null;

  if (!project) {
    return null;
  }

  const loadcaseColor = loadcases_getColor(project, props.guid) || INVALID_COLOR;

  return (
    <span
      className="color-info-box"
      style={{
        backgroundColor: loadcaseColor.toHex(),
      }}
    >
      &nbsp;
    </span>
  );
};

const InfoAlert = (props: any, selectedSection: any, selectedMaterial: any) => {
  const { t, i18n } = useTranslation();

  if (selectedSection === null || selectedMaterial === null) {
    return "";
  }

  let matchOK = false;

  switch (selectedMaterial.type) {
    case ng.material.Mtrl.MTRL_CONCRETE:
      matchOK = selectedSection.materialCategory === ng.sections.MaterialCategory.MATERIAL_CATEGORY_CONCRETE;
      break;
    case ng.material.Mtrl.MTRL_STEEL:
      matchOK = selectedSection.materialCategory === ng.sections.MaterialCategory.MATERIAL_CATEGORY_STEEL;
      break;
    case ng.material.Mtrl.MTRL_TIMBER:
      matchOK = selectedSection.materialCategory === ng.sections.MaterialCategory.MATERIAL_CATEGORY_TIMBER;
      break;
    default:
      break;
  }

  return !matchOK ? <SXAlert status="info" text={t("info_alert.label")} /> : "";
};

export { DEFAULT_BEAM, DEFAULT_CONNECTIVITY, make_state_type, LoadCaseColor, InfoAlert };
